module.exports = __webpack_public_path__ + "static/media/double-arrow-gray.9071a065.svg";